const TableDataRow = ({ className, children, isActive = false, onClick, ...rest }) => {
  return (
    <div className={`${className} ${isActive ? "bg-blue-50" : ""}`} onClick={onClick} {...rest}>
      {children}
    </div>
  )
}

export default TableDataRow
